"use client";

import React from "react";
import MediaQuery from "react-responsive";

import { DEVICE_WIDTHS } from "./consts";

export const TabletUp: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <MediaQuery minWidth={DEVICE_WIDTHS.tablet + 1}>{children}</MediaQuery>;
};

export const TabletDown: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <MediaQuery maxWidth={DEVICE_WIDTHS.tablet}>{children}</MediaQuery>;
};

export const DesktopDown: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <MediaQuery maxWidth={1200}>{children}</MediaQuery>;
};

export const DesktopUp: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <MediaQuery minWidth={1201}>{children}</MediaQuery>;
};
